export enum GeometryType {
  POINT = 'POINT',
  WALL = 'WALL',
  FIGURE = 'FIGURE',
  POSITIONED_LABEL = 'POSITIONED_LABEL',
  POSITIONED_SYMBOL = 'POSITIONED_SYMBOL',
  UNKNOWN = 'UNKNOWN',
}
